module.exports = __webpack_public_path__ + "img/logo.d69c07d7.png";